"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const vueUtils_1 = require("@/client/utils/vueUtils");
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
let unique = 0;
exports.default = vue_1.default.extend({
    name: 'or-options',
    props: {
        playerView: {
            type: Object,
        },
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    components: {
        AppButton: AppButton_vue_1.default,
    },
    data() {
        const displayedOptions = this.playerinput.options.filter((option) => {
            if (option.type !== 'card') {
                return true;
            }
            if (option.showOnlyInLearnerMode === false) {
                return true;
            }
            return (0, PreferencesManager_1.getPreferences)().learner_mode;
        });
        const initialIdx = this.playerinput.initialIdx ?? 0;
        let selectedOption = displayedOptions[initialIdx];
        if (displayedOptions.length > 1 &&
            selectedOption.type === 'card' &&
            !selectedOption.cards.some((card) => card.isDisabled !== true)) {
            selectedOption = displayedOptions[initialIdx + 1];
        }
        return {
            displayedOptions,
            radioElementName: 'selectOption' + unique++,
            selectedOption,
        };
    },
    watch: {
        selectedOption(newOption) {
            const anchorTop = this.getTop(newOption);
            this.$nextTick(() => {
                const newTop = this.getTop(newOption);
                if (anchorTop !== undefined && newTop !== undefined) {
                    const delta = newTop - anchorTop;
                    if (Math.abs(delta) > 0.5) {
                        window.scrollBy(0, delta);
                    }
                }
            });
        },
    },
    methods: {
        getTop(option) {
            if (option === undefined) {
                return undefined;
            }
            const element = this.getOptionLabelElement(option);
            return element?.getBoundingClientRect().top;
        },
        getOptionLabelElement(option) {
            const idx = this.displayedOptions.indexOf(option);
            const refs = this.$refs.optionLabels;
            if (idx === -1 || !refs) {
                return undefined;
            }
            const val = Array.isArray(refs) ? refs[idx] : refs;
            return (0, vueUtils_1.isHTMLElement)(val) ? val : undefined;
        },
        playerFactorySaved() {
            const idx = this.playerinput.options.indexOf(this.selectedOption);
            if (idx === undefined || idx === -1) {
                throw new Error('option not found');
            }
            return (out) => {
                this.onsave({
                    type: 'or',
                    index: idx,
                    response: out,
                });
            };
        },
        saveData() {
            let ref = this.$refs['inputfactory'];
            if (Array.isArray(ref)) {
                ref = ref[0];
            }
            ref.saveData();
        },
    },
});
